import { useEffect, useState } from "react";

import { FiUsers, FiUserPlus, FiUserCheck, FiUserX } from "react-icons/fi";

import { makeRequestAuth } from "../../../_config/api";

export default function DashboardCards() {
  const [data, setData] = useState({
    totalUsers: 0,
    todayUsers: 0,
    activeUsers: 0,
    inactiveUsers: 0,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const res = await makeRequestAuth("get", "/admin/getDashboard");

      if (!res.error) {
        setData(res.data);
      }
    } catch (error) {
      console.error("Dashboard Fetch Error:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const cards = [
    {
      value: data.totalUsers,
      title: "Total Users",
      icon: <FiUsers size={26} />,
      circleColor: "bg-purple-100 text-purple-600 dark:bg-purple-500/20",
      borderColor: "border border-purple-300 dark:border-purple-500/30",
    },
    {
      value: data.todayUsers,
      title: "Today Users",
      icon: <FiUserPlus size={26} />,
      circleColor: "bg-blue-100 text-blue-600 dark:bg-blue-500/20",
      borderColor: "border border-blue-300 dark:border-blue-500/30",
    },
    {
      value: data.activeUsers,
      title: "Active Users",
      icon: <FiUserCheck size={26} />,
      circleColor: "bg-green-100 text-green-600 dark:bg-green-500/20",
      borderColor: "border border-green-300 dark:border-green-500/30",
    },
    {
      value: data.inactiveUsers,
      title: "Inactive Users",
      icon: <FiUserX size={26} />,
      circleColor: "bg-red-100 text-red-600 dark:bg-red-500/20",
      borderColor: "border border-red-300 dark:border-red-500/30",
    },
  ];

  return (
    <div className="p-4 transition-all mt-2">
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
        {cards.map((card, index) => (
          <div
            key={index}
            className={`
              group rounded-xl p-6 flex flex-col justify-between
              bg-white text-gray-800 shadow-sm
              dark:bg-[#1C2535] dark:text-white
              hover:shadow-md transition-all
              ${card.borderColor}
            `}
          >
            <p className="text-3xl font-bold text-gray-900 dark:text-white">
              {loading ? "..." : card.value}
            </p>

            <p className="text-lg font-semibold mt-2 text-gray-600 dark:text-gray-300">
              {card.title}
            </p>

            <div className="mt-6">
              <div
                className={`
                  w-14 h-14 rounded-full flex items-center justify-center
                  group-hover:scale-110 transition-transform
                  ${card.circleColor}
                `}
              >
                {card.icon}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
